// Тексты Title и Description для всех страниц сайта.
// Менять тексты нужно ЗДЕСЬ (и в seo_meta.json на сервере - файлы одинаковые по смыслу).
// Статические тексты взяты дословно из ТЗ заказчика.

export const SITE_NAME = 'Двери-Окна-ОРТ';
export const SITE_URL = 'https://двери-окна-орт.рф';

export const STATIC_META = {
  home: {
    title: 'Купить двери и окна в Новочебоксарске | Двери-Окна-ОРТ',
    description:
      'Широкий выбор межкомнатных и входных дверей, пластиковых окон в Новочебоксарске. Бесплатный ' +
      'замер, доставка, монтаж. Звоните!',
  },
  catalogDoors: {
    title: 'Каталог межкомнатных и входных дверей | Двери-Окна-ОРТ',
    description:
      'Межкомнатные и входные двери в наличии и под заказ. Более 100 моделей от производителей. Цены, ' +
      'фото, характеристики.',
  },
  catalogWindows: {
    title: 'Пластиковые окна на заказ в Новочебоксарске | Двери-Окна-ОРТ',
    description:
      'Качественные пластиковые окна ПВХ. Замер, доставка, профессиональный монтаж. Рассрочка 0%.',
  },
  catalogInteriorDoors: {
    title: 'Межкомнатные двери в Новочебоксарске — каталог с ценами | Двери-Окна-ОРТ',
    description:
      'Межкомнатные двери: царговые, ПВХ, шпон, ламинат, массив. Более 60 моделей в наличии ' +
      'и под заказ, доставка и установка по Новочебоксарску.',
  },
  catalogEntranceDoors: {
    title: 'Входные двери в Новочебоксарске — купить с установкой | Двери-Окна-ОРТ',
    description:
      'Входные двери в наличии и под заказ: металлические, с терморазрывом, с зеркалом. Замер, ' +
      'доставка и установка по Новочебоксарску.',
  },
  catalogRollerShutters: {
    title: 'Рольставни в Новочебоксарске — купить с монтажом | Двери-Окна-ОРТ',
    description:
      'Рольставни для окон, дверей и гаражей: ручное и автоматическое управление. Замер, ' +
      'доставка и установка по Новочебоксарску.',
  },
  catalogAccessories: {
    title: 'Фурнитура для дверей и окон в Новочебоксарске | Двери-Окна-ОРТ',
    description:
      'Ручки, петли, замки и другая фурнитура для межкомнатных и входных дверей, окон ПВХ. ' +
      'Цены, фото, наличие в магазинах Новочебоксарска.',
  },
  catalog: {
    title: 'Каталог дверей, окон и рольставен в Новочебоксарске | Двери-Окна-ОРТ',
    description:
      'Каталог магазина Двери-Окна-ОРТ: межкомнатные и входные двери, пластиковые окна, рольставни, ' +
      'фурнитура. Цены, фото, наличие.',
  },
  about: {
    title: 'О компании Двери-Окна-ОРТ в Новочебоксарске | Двери-Окна-ОРТ',
    description:
      'Компания Двери-Окна-ОРТ — более 5 лет на рынке. Профессиональный монтаж, гарантия на все работы.',
  },
  contacts: {
    title: 'Контакты и адрес магазина Двери-Окна-ОРТ в Новочебоксарске',
    description:
      'Адрес, телефон, режим работы магазина дверей и окон в Новочебоксарске. Схема проезда.',
  },
  articles: {
    title: 'Статьи о дверях и окнах — советы экспертов | Двери-Окна-ОРТ',
    description:
      'Полезные статьи о выборе межкомнатных и входных дверей, пластиковых окон, монтаже и уходе. ' +
      'Советы специалистов Двери-Окна-ОРТ.',
  },
  privacy: {
    title: 'Политика конфиденциальности | Двери-Окна-ОРТ',
    description:
      'Политика обработки персональных данных сайта магазина Двери-Окна-ОРТ в Новочебоксарске.',
  },
  notFound: {
    title: 'Страница не найдена | Двери-Окна-ОРТ',
    description:
      'Такой страницы нет. Перейдите в каталог дверей и окон Двери-Окна-ОРТ в Новочебоксарске.',
  },
};

// Разделы каталога со своим адресом: /catalog/doors, /catalog/entrance-doors,
// /catalog/windows. Открывают тот же каталог с уже выбранным фильтром,
// но у каждого свои Title и Description.
export const CATALOG_SECTIONS = {
  // «Каталог дверей» показывает сразу обе группы - межкомнатные и входные,
  // как и обещает заголовок страницы.
  doors: {
    types: ['interior_door', 'entrance_door'],
    meta: STATIC_META.catalogDoors,
  },
  'interior-doors': {
    type: 'interior_door',
    meta: STATIC_META.catalogInteriorDoors,
  },
  'entrance-doors': {
    type: 'entrance_door',
    meta: STATIC_META.catalogEntranceDoors,
  },
  windows: { type: 'window', meta: STATIC_META.catalogWindows },
  'roller-shutters': {
    type: 'roller_shutters',
    meta: STATIC_META.catalogRollerShutters,
  },
  accessories: { type: 'accessories', meta: STATIC_META.catalogAccessories },
};

// Плитки каталога ведут на адрес своего раздела - так у каждой группы
// товаров свой заголовок и описание.
export const TYPE_TO_SECTION = {
  interior_door: 'interior-doors',
  entrance_door: 'entrance-doors',
  window: 'windows',
  roller_shutters: 'roller-shutters',
  accessories: 'accessories',
};

// Шаблоны для страниц, которые рисуются из админки.
const PRODUCT_TEMPLATES = {
  door: {
    title: (name) => `Купить ${name} в Новочебоксарске | Двери-Окна-ОРТ`,
    description: (name) =>
      `${name} — цена, фото, размеры. В наличии и под заказ. Бесплатная доставка по Новочебоксарску.`,
  },
  window: {
    title: (name) => `Купить пластиковое окно ${name} в Новочебоксарске | Двери-Окна-ОРТ`,
    description: (name) =>
      `${name} — цена, характеристики, профиль. Замер бесплатно. Монтаж в день заказа.`,
  },
  other: {
    title: (name) => `Купить ${name} в Новочебоксарске | Двери-Окна-ОРТ`,
    description: (name) =>
      `${name} — цена, фото, характеристики. В наличии и под заказ. Доставка и монтаж по Новочебоксарску.`,
  },
};

const TYPE_TO_TEMPLATE = {
  interior_door: 'door',
  entrance_door: 'door',
  window: 'window',
  roller_shutters: 'other',
  accessories: 'other',
};

// Текст без разметки. Конец абзаца превращаем в точку, иначе заголовок
// статьи слипается со следующим предложением прямо в описании.
const BLOCK_MARK = '\u0001';

export function stripHtml(value) {
  if (!value) return '';
  const marked = String(value)
    .replace(/<\/(p|div|h[1-6]|li|tr|section|article|blockquote)\s*>/gi, BLOCK_MARK)
    .replace(/<br\s*\/?>/gi, BLOCK_MARK)
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&mdash;/g, '—')
    .replace(/&ndash;/g, '–')
    .replace(/&laquo;/g, '«')
    .replace(/&raquo;/g, '»')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&');

  const chunks = marked
    .split(BLOCK_MARK)
    .map(chunk => chunk.replace(/\s+/g, ' ').trim())
    .filter(Boolean);

  // Точку в конце абзаца ставим, только если дальше начинается новая мысль
  // (следующий кусок с заглавной). Иначе это перенос строки внутри фразы.
  const parts = chunks.map((chunk, index) => {
    const following = chunks[index + 1] || '';
    const startsNew = following.slice(0, 1) !== following.slice(0, 1).toLowerCase();
    return /[.!?:;]$/.test(chunk) || !startsNew ? chunk : `${chunk}.`;
  });

  return (parts.length ? parts.join(' ') : marked)
    .replace(/\s+([,.;:!?])/g, '$1')
    .replace(/\s+/g, ' ')
    .trim();
}

// Короткое описание статьи: режем по концу предложения, а если его нет -
// по последнему слову, отбрасывая «хвост» из предлогов и союзов.
const TAIL_WORDS = new Set([
  'и', 'а', 'но', 'или', 'да', 'что', 'как', 'в', 'во', 'на', 'за', 'из',
  'от', 'до', 'по', 'к', 'ко', 'с', 'со', 'у', 'о', 'об', 'обо', 'для',
  'при', 'про', 'над', 'под', 'без', 'через', 'между', 'если', 'чтобы',
  'то', 'же', 'ли', 'бы',
]);

const SENTENCE_RE = /[^.!?]+[.!?]+\s*|[^.!?]+$/g;
const ARTICLE_SHORT_TAIL =
  'Магазин дверей и окон Двери-Окна-ОРТ в Новочебоксарске: замер, доставка, монтаж.';
const EXCERPT_SHORT_FLOOR = 140; // ниже нижней границы ТЗ описание опускать нельзя

// Описание статьи по ТЗ - 140-160 знаков. Собираем целыми предложениями:
// одно короткое предложение описания не даёт, обрубок на предлоге тоже.
export function makeExcerpt(value, limit = 155, minimum = 140) {
  const text = stripHtml(value);
  if (text.length <= limit) return text;

  let picked = '';
  const sentences = text.match(SENTENCE_RE) || [];
  for (const sentence of sentences) {
    const candidate = picked
      ? `${picked} ${sentence.trim()}`.trim()
      : sentence.trim();
    if (candidate.length > limit && picked.length >= minimum) break;
    picked = candidate;
    if (picked.length >= minimum && /[.!?]$/.test(picked)) break;
  }

  if (picked.length >= minimum && picked.length <= limit + 10) {
    return picked.trim();
  }

  // Предложения не подошли по длине - добираем словами и ставим многоточие:
  // фраза оборвана, и выдуманная точка выглядела бы как ошибка.
  const words = text.slice(0, limit + 3).split(' ');
  words.pop(); // последнее слово почти всегда обрублено
  while (words.length && TAIL_WORDS.has(words[words.length - 1].toLowerCase())) {
    words.pop();
  }
  const tail = words.join(' ').replace(/[\s,.;:—-]+$/, '');

  // Огрызок в пару слов после последней точки читается хуже, чем чуть более
  // короткое, но законченное предложение - в таком случае режем по точке.
  const lastStop = Math.max(
    tail.lastIndexOf('.'),
    tail.lastIndexOf('!'),
    tail.lastIndexOf('?'),
  );
  if (lastStop >= EXCERPT_SHORT_FLOOR && tail.length - lastStop <= 30) {
    return tail.slice(0, lastStop + 1).trim();
  }
  return `${tail}…`;
}

// Мета карточки товара: name приходит из админки.
export function productMeta(product) {
  if (!product) return STATIC_META.catalog;
  // склеиваем двойные и неразрывные пробелы, иначе тексты расходятся
  const name = (product.name || '').replace(/[\s ]+/g, ' ').trim();
  const template = PRODUCT_TEMPLATES[TYPE_TO_TEMPLATE[product.type] || 'other'];
  const album = product.productalbum || [];
  const photo = album.length ? album[0].image : '';
  return {
    title: template.title(name),
    description: template.description(name),
    // картинка для предпросмотра ссылки в мессенджерах - первое фото товара
    image: photo && !photo.startsWith('http') ? `${SITE_URL}${photo}` : photo,
  };
}

// Мета статьи: title и текст приходят из админки.
export function articleMeta(article) {
  if (!article) return STATIC_META.articles;
  // точку на конце названия убираем, иначе выходит «на заказ. — советы экспертов»
  const title = (article.title || '').trim().replace(/\.+$/, '');
  let excerpt = makeExcerpt(article.text);
  // У короткой новости текст может кончаться без точки - тогда обязательная
  // фраза из ТЗ приклеивается вплотную. Ставим точку и добираем заголовком.
  if (excerpt && !/[.!?…]$/.test(excerpt)) excerpt += '.';
  if (excerpt.length < 140 && title) {
    excerpt = excerpt ? `${title}. ${excerpt}`.trim() : `${title}.`;
  }
  let description = `${excerpt} Полезная информация о выборе дверей и окон.`;
  // Совсем короткая новость: дописываем фразу о магазине, чтобы описание
  // не выходило вдвое короче нормы.
  if (description.length < 140) {
    description = `${description} ${ARTICLE_SHORT_TAIL}`;
  }
  return {
    title: `${title} — советы экспертов | Двери-Окна-ОРТ`,
    description,
  };
}
